export enum TenantRoute {
    trs = "TRS",
    cna = "CNA",
    clarkPro = "ClarkPro",
    wss = "WSS",
    tax = "Tax",
    risk = "Risk",
    rkw = "RKW",
}
